var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItemuncheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1152,
    zoomAndPan: "magnify",
    viewBox: "0 0 864 863.999991",
    height: 1152,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3062a4201b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.789062 17.789062 L 846.210938 17.789062 L 846.210938 846.210938 L 17.789062 846.210938 Z M 17.789062 17.789062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4aeba4fe73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 432 17.789062 C 203.238281 17.789062 17.789062 203.238281 17.789062 432 C 17.789062 660.761719 203.238281 846.210938 432 846.210938 C 660.761719 846.210938 846.210938 660.761719 846.210938 432 C 846.210938 203.238281 660.761719 17.789062 432 17.789062 Z M 432 17.789062 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3062a4201b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4aeba4fe73)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 17.789062 17.789062 L 846.210938 17.789062 L 846.210938 846.210938 L 17.789062 846.210938 Z M 17.789062 17.789062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 17.788238, 17.788254)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 552.282378 0.00107816 C 247.266737 0.00107816 0.00109903 247.266716 0.00109903 552.282357 C 0.00109903 857.297998 247.266737 1104.563635 552.282378 1104.563635 C 857.298018 1104.563635 1104.563656 857.297998 1104.563656 552.282357 C 1104.563656 247.266716 857.298018 0.00107816 552.282378 0.00107816 Z M 552.282378 0.00107816 ",
    stroke: "#b8b8b8",
    strokeWidth: 130,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemuncheck);
export default __webpack_public_path__ + "static/media/itemuncheck.c8a09d9accd28ed7d75bb396ea8557c6.svg";
export { ForwardRef as ReactComponent };